export const tagTypes = {
  UnitPendingLeadershipPositions: 'UnitPendingLeadershipPositions',
  UnitLeadershipPositions: 'UnitLeadershipPositions',
  YouthRankVersionDetails: 'YouthRankVersionDetails',
  AdventureUserRequirements: 'AdventureUserRequirements',
  MeritBadgeUserRequirements: 'MeritBadgeUserRequirements',
  OrganizationProfile: 'OrganizationProfile',
  OrganizationAdvDashboard: 'OrganizationAdvDashboard',
  OrganizationActivitiesDashboard: 'OrganizationActivitiesDashboard',
  RankDetails: 'RankDetails',
  RankRequirements: 'RankRequirements',
  AdventureRequirements: 'RankRequirements',
  YouthLeadershipPositions: 'YouthLeadershipPositions',
  YouthRankDetails: 'YouthRankDetails',
  YouthRankRequirements: 'YouthRankRequirements',
  PersonRenewalRelationships: 'PersonRenewalRelationships',
  PersonProfile: 'PersonProfile',
  PersonMystProfile: 'PersonMystProfile',
  PersonSubscriptions: 'PersonSubscriptions',
  CompletePersonProfile: 'CompletePersonProfile',
  AdvancementHistory: 'AdvancementHistory',
  PaymentLogSummary: 'PaymentLogSummary',
  PaymentLogBalance: 'PaymentLogBalance',
  PaymentLogQuery: 'PaymentLogQuery',
  PaymentLogCategories: 'PaymentLogCategories',
  PersonTrainingYPT: 'PersonTrainingYPT',
  UnitDenchiefs: 'UnitDenchiefs',
  BulkMeritBadgeBlueCard: 'BulkMeritBadgeBlueCard',
  SubUnits: 'SubUnits',
  UnitRoster: 'UnitRoster',
  OrganizationRoster: 'OrganizationRoster',
  PurchaseOrders: 'PurchaseOrders',
  OrgAdvancementsReadyToAward: 'OrgAdvancementsReadyToAward',
  OrganizationPositions: 'OrganizationPositions',
  AdvancementImports: 'AdvancementImports',
  RelationshipSearch: 'RelationshipSearch',
  UserRoleTypes: 'UserRoleTypes',
  MembershipRegistration: 'MembershipRegistration',
  UnitRenewalOrders: 'UnitRenewalOrders',
  // Arnica
  ReportsList: 'ReportsList',
  CustomReports: 'CustomReports',
  // Collections
  Activities: 'Activities',
  Adventure: 'Adventure',
  Rank: 'Rank',
  Event: 'Event',
  AdvancementDetails: 'AdvancementDetails',
  PermissionSlips: 'PermissionSlips',
  UnitEvents: 'UnitEvents',
  UnitEventHealthMetrics: 'UnitEventHealthMetrics',
  YouthAdventure: 'YouthAdventure',
  YouthAward: 'YouthAward',
  YouthMeritBadge: 'YouthMeritBadge',
  YouthRanks: 'YouthRanks',
  YouthSSElectives: 'YouthSSElectives',
  UnitSearchResult: 'UnitSearch',
  UserActivitySummary: 'UserActivitySummary',
} as const;
